var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAoLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "20px",
    viewBox: "0 0 31 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Measurabl_Mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav/Header---NEW",
    transform: "translate(-30.000000, -30.000000)",
    fill: "#2DB892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Measurabl_Mark",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1610181,3.10814104 C17.4381622,1.20657649 15.7742715,0 12.8799098,0 C10.3477106,0 8.06821703,1.42561653 6.69302789,2.5958101 L6.69302789,0.402439666 L0,0.402439666 L0,8.55963924 L2.88407722,8.55963924 C3.14780205,8.55963924 3.36157344,8.77496674 3.36157344,9.04301235 C3.36157344,9.30883043 3.14780205,9.52564294 2.88407722,9.52564294 L0,9.52564294 L0,10.6007954 L1.3031974,10.6007954 C1.56618763,10.6007954 1.77922441,10.8183504 1.77922441,11.084911 C1.77922441,11.3522141 1.56618763,11.5675416 1.3031974,11.5675416 L0,11.5675416 L0,12.5342878 L2.73127842,12.5342878 C2.99573787,12.5342878 3.20877465,12.7511003 3.20877465,13.0169184 C3.20877465,13.284964 2.99573787,13.501034 2.73127842,13.501034 L0,13.501034 L0,14.4670377 L1.3031974,14.4670377 C1.56618763,14.4670377 1.77922441,14.6838502 1.77922441,14.9511533 C1.77922441,15.219199 1.56618763,15.4345265 1.3031974,15.4345265 L0,15.4345265 L0,16.4012727 L2.73127842,16.4012727 C2.99573787,16.4012727 3.20877465,16.6173427 3.20877465,16.8831607 C3.20877465,17.1512064 2.99573787,17.3657913 2.73127842,17.3657913 L0,17.3657913 L0,19.5999997 L6.69302789,19.5999997 L6.69302789,7.13105268 C7.56207103,6.18064166 8.93652555,5.19310521 10.2389883,5.19310521 C11.7941568,5.19310521 12.0483317,6.25192249 12.0483317,7.75178988 L12.0483317,19.5999997 L18.6678987,19.5999997 L18.6678987,7.24020144 C19.5369418,6.25192249 20.9488614,5.19310521 22.2858509,5.19310521 C23.8057581,5.19310521 24.0232025,6.25192249 24.0232025,7.75178988 L24.0232025,19.5999997 L30.7176996,19.5999997 L30.7176996,6.14277372 C30.7176996,2.26687878 28.980348,0 24.891511,0 C21.9604188,0 19.4289542,1.86443912 18.1610181,3.10814104",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAoLogoMark);
export default __webpack_public_path__ + "static/media/ao__logo-mark.096cf3afc5a4d9691e34265836f920f5.svg";
export { ForwardRef as ReactComponent };